import bem from '../modules/bem';
import viewport from '../modules/viewport';

const variables = require('../../variables.json');

class RaceNav {

	static get block() {
		return bem.block('race-nav');
	}

	constructor($raceNav){

		this.$raceNav = $raceNav;
		this.$raceNavHeader = document.querySelector(RaceNav.block.selector('header'));
		this.$raceNavToggle = document.querySelector(RaceNav.block.selector('toggle'));
		this.$raceNavContent = document.querySelectorAll(RaceNav.block.selector('content'));
		this.$tabs = document.querySelector(RaceNav.block.selector('tabs'));
		this.$tabsLinks = document.querySelector(bem.block('tabs').selector('links'));
		this.$body = document.querySelector('body');

		this.active = false;
		this.fixed = false;
		this.tabs = null;
		this.timer = null;

		this.settings = {
			delay: 400,
			offset: variables['site-header'].primary + variables['site-header'].secondary
		};

		this.init = this.init.bind(this);
		this.onResize = this.onResize.bind(this);
		this.toggleActive = this.toggleActive.bind(this);
		this.contentHeight = this.contentHeight.bind(this);
		this.mouseHandler = this.mouseHandler.bind(this);
		this.touchHandler = this.touchHandler.bind(this);
		this.cleanUp = this.cleanUp.bind(this);

		this.init();

	}

	init(){

		this.tabs = new atr.classes.Tabs(this.$tabs);

		viewport.addListener('race-nav', this.onResize);
		this.onResize();

		if( Modernizr.touchevents ){

			$(this.$raceNavHeader).on('touchend', this.touchHandler);
			$(this.$raceNavToggle).on('touchend', this.touchHandler);

			$(this.$raceNav)
				.on('touchend', function(e){

					e.stopPropagation();

				});

		}

		$(this.$raceNav).on('mouseenter mouseleave mouseup', this.mouseHandler);
		$(this.$raceNavToggle).on('mouseenter mouseleave mouseup', this.mouseHandler);

	}

	onResize(){

		this.tabs.overflowReset();

	}

	toggleActive(force){

		this.$raceNav.classList.toggle(bem.states.active, force);
		this.$raceNavToggle.classList.toggle(bem.states.active, force);

		if( force ){

			this.tabs.overflowReset();

			this.contentHeight();

		}

		this.active = force;

	}

	contentHeight(){

		let contentHeight = 0;
		contentHeight = viewport.height;
		contentHeight -= this.settings.offset;
		contentHeight -= this.$raceNav.offsetHeight;
		contentHeight -= this.$tabsLinks.offsetHeight;
		contentHeight -= 10; // for bottom gap

		if( !this.fixed ){
			contentHeight -= 10; // for gap above the race nav
		}

		// this.fixed ? contentHeight : contentHeight.default;

		for( let i = 0; i < this.$raceNavContent.length; i++ ){
			const $item = this.$raceNavContent[i];

			$item.style.maxHeight = contentHeight + 'px';
		}

	}

	mouseHandler(e){

		clearTimeout(this.timer);

		const active = this.active;
		const toggleActive = this.toggleActive;

		if( e.type === 'mouseenter' || e.type === 'mouseup' ){

			this.timer = setTimeout(function(){

				if( active ) return;

				toggleActive(true);

			}, e.type === 'mouseup' ? 0 : this.settings.delay);

		}else{

			this.timer = setTimeout(function(){

				if( !active ) return;

				toggleActive(false);

			}, this.settings.delay);

		}

		e.preventDefault();

	}

	touchHandler(){

		const $body = $(this.$body);
		const cleanUp = this.cleanUp;

		if( !this.active ){

			this.toggleActive(true);

			setTimeout(function(){

				$body
					.on('touchend.rn', cleanUp);

			}, 50);

		}

	}

	cleanUp(){

		$(this.$body).off('touchend.rn');
		this.toggleActive(false);

	}

}

module.exports = RaceNav;

// module.exports = () => {
// 	const $raceNav = document.querySelector(RaceNav.block.selector());

// 	if( !$raceNav ){
// 		return;
// 	}

// 	new RaceNav($raceNav); // eslint-disable-line no-new
// };



// WEBPACK FOOTER //
// ./src/js/layout/race-nav.js